var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloseIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67 -0.000732422H14.34C17.73 -0.000732422 20 2.37927 20 5.91927V14.0903C20 17.6203 17.73 19.9993 14.34 19.9993H5.67C2.28 19.9993 0 17.6203 0 14.0903V5.91927C0 2.37927 2.28 -0.000732422 5.67 -0.000732422ZM13.01 12.9993C13.35 12.6603 13.35 12.1103 13.01 11.7703L11.23 9.99027L13.01 8.20927C13.35 7.87027 13.35 7.31027 13.01 6.97027C12.67 6.62927 12.12 6.62927 11.77 6.97027L10 8.74927L8.22 6.97027C7.87 6.62927 7.32 6.62927 6.98 6.97027C6.64 7.31027 6.64 7.87027 6.98 8.20927L8.76 9.99027L6.98 11.7603C6.64 12.1103 6.64 12.6603 6.98 12.9993C7.15 13.1693 7.38 13.2603 7.6 13.2603C7.83 13.2603 8.05 13.1693 8.22 12.9993L10 11.2303L11.78 12.9993C11.95 13.1803 12.17 13.2603 12.39 13.2603C12.62 13.2603 12.84 13.1693 13.01 12.9993Z",
    fill: "#B0B0B0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloseIcon.d93d5d14.svg";
export { ForwardRef as ReactComponent };